import { render, staticRenderFns } from "./OfferList.vue?vue&type=template&id=63f6b626&"
import script from "./OfferList.vue?vue&type=script&lang=js&"
export * from "./OfferList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports